import { BOOKINGS_APP_DEF_ID, PRICING_PLAN_APP_DEF_ID, PRICING_PLAN_SECTION_ID } from '@wix/bookings-catalog-calendar-viewer-utils';
import { getPricingPlansPublicAPI } from '@wix/pricing-plans-tpa-api';
const getPricingPlansApi = async wixCodeApi => {
  if (!getPricingPlansApi.pricingPlansApi) {
    getPricingPlansApi.pricingPlansApi = await getPricingPlansPublicAPI(wixCodeApi);
  }
  return getPricingPlansApi.pricingPlansApi;
};
async function getPricingPlanUrl(wixCodeApi) {
  const fullPricingPlanUrl = (await wixCodeApi.site.getSectionUrl({
    sectionId: PRICING_PLAN_SECTION_ID,
    appDefinitionId: PRICING_PLAN_APP_DEF_ID
  })).url;
  const baseUrl = wixCodeApi.location.baseUrl;
  if (baseUrl) {
    const urlParts = fullPricingPlanUrl.split(baseUrl);
    return urlParts.length > 1 ? urlParts[1] : fullPricingPlanUrl;
  }
  return fullPricingPlanUrl;
}
export async function navigateToPricingPlan(_ref) {
  let {
    wixCodeApi,
    redirectTo,
    planIds,
    maxStartDate,
    queryParams,
    title,
    subtitle,
    isChangePricingPlanNavigationToNewApiEnabled
  } = _ref;
  if (isChangePricingPlanNavigationToNewApiEnabled) {
    const api = await getPricingPlansApi(wixCodeApi);
    return api.navigateToPackagePicker({
      planIds,
      title,
      subtitle,
      checkout: {
        maxStartDate,
        successStatus: {
          navigation: {
            type: 'section',
            options: {
              appDefinitionId: BOOKINGS_APP_DEF_ID,
              sectionId: redirectTo.sectionId,
              state: redirectTo.relativePath,
              queryParams
            }
          }
        }
      }
    });
  }
  const pricingPlanUrl = await getPricingPlanUrl(wixCodeApi);
  const callbackData = btoa(JSON.stringify({
    appDefinitionId: BOOKINGS_APP_DEF_ID,
    sectionId: redirectTo.sectionId,
    state: redirectTo.relativePath,
    queryParams
  }));
  const pricingPlanSectionParams = encodeURIComponent(JSON.stringify({
    navigateToSectionProps: callbackData,
    planIds: planIds == null ? void 0 : planIds.join(','),
    title,
    subtitle,
    maxStartDate
  }));
  wixCodeApi.location.to(pricingPlanUrl + "?appSectionParams=" + pricingPlanSectionParams);
}
export async function navigateToPricingPlanPreview(_ref2) {
  let {
    wixCodeApi,
    title,
    subtitle,
    isChangePricingPlanNavigationToNewApiEnabled
  } = _ref2;
  if (isChangePricingPlanNavigationToNewApiEnabled) {
    const api = await getPricingPlansApi(wixCodeApi);
    return api.navigateToPackagePicker({
      title,
      subtitle
    });
  }
  const pricingPlanUrl = await getPricingPlanUrl(wixCodeApi);
  if (title || subtitle) {
    const pricingPlanSectionParams = encodeURIComponent(JSON.stringify({
      title,
      subtitle
    }));
    wixCodeApi.location.to(pricingPlanUrl + "?appSectionParams=" + pricingPlanSectionParams);
  } else {
    wixCodeApi.location.to(pricingPlanUrl);
  }
}
//# sourceMappingURL=navigateToPricingPlan.js.map